export const DUE_DATE_OPTIONS_IDS = {
  SELECT_DATE: "-1",
  DAY_OF_COURSE: " 1",
  WEEK_BEFORE: "2",
  TWO_WEEKS_BEFORE: " 3",
  MONTH_BEFORE: " 4",
  REGISTRATION_DAY: " 5",
};

export const DUE_DATE_OPTIONS = [
  { label: "wybierz datę", value: DUE_DATE_OPTIONS_IDS.SELECT_DATE },
  { label: "dzień rozpoczęcia kursu", value: DUE_DATE_OPTIONS_IDS.DAY_OF_COURSE },
  { label: "tydzień przed rozpoczęciem kursu", value: DUE_DATE_OPTIONS_IDS.WEEK_BEFORE },
  { label: "2 tyg. przed rozpoczęciem kursu", value: DUE_DATE_OPTIONS_IDS.TWO_WEEKS_BEFORE },
  { label: "miesiąc przed rozpoczęciem kursu", value: DUE_DATE_OPTIONS_IDS.MONTH_BEFORE },
  { label: "do 3 dni po zapisie", value: DUE_DATE_OPTIONS_IDS.REGISTRATION_DAY },
];
